// src/json/overlayData.json
export const overlaySectionCaulkingSealantRenewal = {
    imageUrl: "/assets/imgs/services/2Caulking&SealantRenewal/overlaySection/fondo.jpg",
    text: "The best Building Envelope Renewal /",
    highlight: "High-Rise Painting & Restoration services."
};
